import { characterUri, faceOf, type Tone } from './characters';
import styles from './chat.module.css';

/**
 * A face for the chat and for Nearby: not a person but an odd little character from Bridge's own pack
 * (characters.ts), picked from a seed — the bridge and the writer's role in a chat, the device's name nearby — so both
 * devices see the same one. In a chat the two sides never share a colour: the bridge's owner is Charcoal, the guest
 * Passwork Blue; elsewhere the seed picks the colour too.
 */

/** The colour for a seed: by role in a chat (`…:owner`, `…:guest`), by the seed otherwise. */
export function toneOf(seed: string): Tone {
  if (seed.endsWith(':owner')) return 'charcoal';
  if (seed.endsWith(':guest')) return 'blue';
  return faceOf(`${seed}#tone`) % 2 === 0 ? 'charcoal' : 'blue';
}

/** The face for a seed as an image address. */
export function avatarUri(seed: string): string {
  return characterUri(faceOf(seed), toneOf(seed));
}

/** The face for a seed. `className` sizes and frames it (the chat's 36 px circle by default). */
export function Avatar({ seed, size = 36, className }: { readonly seed: string; readonly size?: number; readonly className?: string }): React.JSX.Element {
  return <img className={className ?? styles.face} src={avatarUri(seed)} alt="" width={size} height={size} draggable={false} />;
}
